import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from './LoginMenu.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/useTranslation';

export default function LoginMenu() {
    const { t } = useTranslation('translation');
    return (
        <div className={styles.container}>
            <div className={styles.header}>{t('loginForm.LOGIN_MENU')}</div>
            <Link to="/login" className={styles.menu_row}>
                <FontAwesomeIcon icon={faChevronRight} className={styles.icon} size="xs" />
                {t('LOGIN')}
            </Link>
            <Link to="/register" className={styles.menu_row}>
                <FontAwesomeIcon icon={faChevronRight} className={styles.icon} size="xs" />
                {t('REGISTER')}
            </Link>
            <Link to="/reset-password" className={styles.menu_row}>
                <FontAwesomeIcon icon={faChevronRight} className={styles.icon} size="xs" />
                {t('RESTORE_PASSWORD')}
            </Link>
        </div>
    );
}
